import { Injectable } from '@angular/core';
import { forkJoin } from 'rxjs';
import { ExportConfigService } from '../data';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';

@Injectable()
export class TemplateService {

    constructor(private exportConfigService: ExportConfigService, private translateService: TranslateService) {
    }

    buildTaskTemplate(activeTaskNode, task, recommendations) {

        return new Promise(resolve => {

            this.exportConfigService.getTaskTemplate().subscribe((resTask) => {

                this.exportConfigService.getAdittionalProposalTemplate().subscribe(resAP => {

                    this.exportConfigService.getFactObservedTemplate().subscribe(resFO => {

                        this.exportConfigService.getRecommendationTemplate().subscribe(resRec => {

                            let html: string = resTask;

                            html = _.replace(html, '$TASK_NAME', activeTaskNode.title);
                            html = _.replace(html, '{lastUser.fullName}', task.lastUser.fullName);
                            html = _.replace(html, '{dateInsert}', task.dateInsert);
                            let isImportantLiteral: string = activeTaskNode.isImportant ? this.translateService.instant('TASK.PRIORITY.HIGH') : this.translateService.instant('TASK.PRIORITY.LOW');
                            html = _.replace(html, '$IS_IMPORTANT', isImportantLiteral);
                            html = _.replace(html, '{typeStateNode.txtState}', task.typeStateNode ? task.typeStateNode.txtState : '');
                            html = _.replace(html, '{txtoDescription}', (task.txtoDescription ? task.txtoDescription : ""));
                            let titleFO = this.translateService.instant('TASK.FACTOBSERVER.LABEL');
                            html = _.replace(html, '[TASK.FACTOBSERVER.LABEL]', titleFO);

                            let titleAP = this.translateService.instant('TASK.ADDITIONALPROPOSAL.LABEL');
                            html = _.replace(html, '[TASK.ADDITIONALPROPOSAL.LABEL]', titleAP);

                            let titleJobDone = this.translateService.instant('WORKS.DONE');
                            html = _.replace(html, '[WORKS.DONE]', titleJobDone);
                            html = _.replace(html, '{txtoJob}', task.txtoJob);


                            let allFO = "";
                            let allAP = "";

                            if (!_.isUndefined(task.factObserver) && !_.isEmpty(task.factObserver)) {

                                let recoIds = _.flatten(_.map(task.factObserver, (item: any)  => {
                                    const ids = _.map(item.recommendation, (reco: any) => reco.idtSqn);
                                    return ids;
                                }));

                                if (!_.isUndefined(recoIds) && !_.isEmpty(recoIds)) {



                                    _.forEach(task.factObserver, (item) => {

                                        item.recommendation = _.filter(recommendations, (it: any) => it.factObserver === item.idFactObserverPk);

                                        allFO += this.buildFactObservedItemTemplate(resFO, resRec, item);
                                    })

                                    html = _.replace(html, '$ALL_FO', allFO);



                                } else {

                                    _.forEach(task.factObserver, (item) => {
                                        allFO += this.buildFactObservedItemTemplate(resFO, resRec, item);
                                    })

                                    html = _.replace(html, '$ALL_FO', allFO);

                                }

                            } else {
                                html = _.replace(html, '$ALL_FO', '');
                            }


                            if (!_.isUndefined(task.additionalProposal) && !_.isEmpty(task.additionalProposal)) {

                                _.forEach(task.additionalProposal, (item) => {

                                    allAP += this.buildAdditionalProposalItemTemplate(resAP, item);
                                })

                                html = _.replace(html, '$ALL_AP', allAP);

                            } else {
                                html = _.replace(html, '$ALL_AP', '');
                            }

                            resolve(html);

                        });

                    })

                });

            })

        })

    }

    buildFactObservedItemTemplate(htmlFactObserved, htmlRecommendation, factObserver) {

        htmlFactObserved = _.replace(htmlFactObserved, '{name}', factObserver.name);
        htmlFactObserved = _.replace(htmlFactObserved, '{description}', factObserver.description);

        let titleRecommendations = this.translateService.instant('TASK.RECOMMENDATION.LABEL');
        htmlFactObserved = _.replace(htmlFactObserved, '[TASK.RECOMMENDATION.LABEL]', titleRecommendations);

        let allReco = '';

        _.forEach(factObserver.recommendation, (item) => {
            allReco += this.buildRecommendationItemTemplate(htmlRecommendation, item);
        });

        htmlFactObserved = _.replace(htmlFactObserved, '$ALL_RECOMMENDATIONS', allReco);


        return htmlFactObserved;

    }

    buildRecommendationItemTemplate(htmlRecommendation, recommendation) {

        htmlRecommendation = _.replace(htmlRecommendation, '{name}', recommendation.name);

        htmlRecommendation = _.replace(htmlRecommendation, '{department.txtDepartment}', recommendation.department ? recommendation.department.txtDepartment : '');

        htmlRecommendation = _.replace(htmlRecommendation, '{text}', recommendation.text ? recommendation.text : '');

        htmlRecommendation = _.replace(htmlRecommendation, '{typeCritique.txtTypeCritiqueFact}', recommendation.typeCritique ? recommendation.typeCritique.txtTypeCritiqueFact : '');

        let tags = [];

        if (recommendation.entities) {
            tags = _.map(tags, (item) => { return item.tag });
        }

        let tagsTemplate = this.buildTagsTemplate(tags);

        htmlRecommendation = _.replace(htmlRecommendation, '$ALL_TAGS', tagsTemplate);

        let risksTemplate = this.buildRisksTemplate(recommendation.risks);

        htmlRecommendation = _.replace(htmlRecommendation, '$ALL_RISKS', risksTemplate);

        let entities = [];

        if (recommendation.entities) {
            entities = _.map(entities, (item) => { return item.entity });
        }

        let entitiesTemplate = this.buildEntitiesTemplate(entities);

        htmlRecommendation = _.replace(htmlRecommendation, '$ALL_ENTITIES', entitiesTemplate);

        htmlRecommendation = _.replace(htmlRecommendation, '{associatedRecommendationName}', recommendation.associatedRecommendationName ? recommendation.associatedRecommendationName : '');

        let processesTemplate = this.buildProcessesTemplate(recommendation.processes);

        htmlRecommendation = _.replace(htmlRecommendation, '$ALL_PROCESSES', processesTemplate);

        htmlRecommendation = _.replace(htmlRecommendation, '{status}', recommendation.status ? recommendation.status.txtTypeStatusRecommendation : '');

        htmlRecommendation = _.replace(htmlRecommendation, '{actionPlan.userResponsible.cdNuuma}', (recommendation.actionPlan && recommendation.actionPlan.userResponsible) ? recommendation.actionPlan.userResponsible.cdNuuma : '');

        if (recommendation.actionPlan && recommendation.actionPlan.responsible) {

            let trackingResponsible: any = _.filter(recommendation.actionPlan.responsible, (item: any)  => { return item.typeResponsability.txtState === 'RESPONSABILIDAD_DE_SEGUIMIENTO' });

            htmlRecommendation = _.replace(htmlRecommendation, '{tracking-responsible}', (_.get(trackingResponsible, '[0].user')) ? trackingResponsible[0].user.cdNuuma : '');

            let executionResponsible: any = _.filter(recommendation.actionPlan.responsible, (item: any) => { return item.typeResponsability.txtState === 'RESPONSABILIDAD_DE_EJECUCION' });

            if (executionResponsible) {
                htmlRecommendation = _.replace(htmlRecommendation, '{execution-responsible}', (_.get(executionResponsible, '[0].user')) ? executionResponsible[0].user.cdNuuma : '');
            }

        } else {

            htmlRecommendation = _.replace(htmlRecommendation, '{tracking-responsible}', '');
            htmlRecommendation = _.replace(htmlRecommendation, '{execution-responsible}', '');
        }

        htmlRecommendation = _.replace(htmlRecommendation, '{actionPlan.executionDate}', recommendation.actionPlan ? recommendation.actionPlan.executionDate : '');

        htmlRecommendation = _.replace(htmlRecommendation, '{actionPlan.expirationDate}', recommendation.actionPlan ? recommendation.actionPlan.expirationDate : '');

        htmlRecommendation = _.replace(htmlRecommendation, '{actionPlan.progressDegree}', recommendation.actionPlan ? recommendation.actionPlan.progressDegree : '');

        htmlRecommendation = _.replace(htmlRecommendation, '{actionPlan.text}', recommendation.actionPlan ? recommendation.actionPlan.text : '');


        let commentsTemplate = this.buildCommentsTemplate(recommendation.comments);

        htmlRecommendation = _.replace(htmlRecommendation, '$ALL_COMMENTS', commentsTemplate);

        let translations = _.words(htmlRecommendation, /\[.*?\]/g);

        _.forEach(translations, item => {

            let aux = _.replace(item, /\[+(.*?)\]+/g, '$1');

            let translation = this.translateService.instant(aux);

            htmlRecommendation = _.replace(htmlRecommendation, item, translation);

        })

        return htmlRecommendation;

    }

    buildTagsTemplate(tags) {

        let template: string = '';

        if (tags) {

            _.forEach(tags, (item) => {
                template += '<div class=""><span class="cursor-pointer">' + item.txtName + '</span></div>';
            })
        }

        return template;

    }

    buildRisksTemplate(risks) {

        let template: string = '';

        if (risks) {

            _.forEach(risks, (item) => {
                template += '<div class=""><span class="cursor-pointer">' + item.riskType.description + '</span></div>';
            })
        }

        return template;

    }

    buildEntitiesTemplate(entities) {

        let template: string = '';

        if (entities) {

            _.forEach(entities, (item) => {
                template += '<div class=""><span class="cursor-pointer">' + item.txtName + '</span></div>';
            })
        }

        return template;

    }


    buildProcessesTemplate(processes) {

        let template: string = '';

        if (processes) {

            _.forEach(processes, (item) => {

                let sector = !_.isUndefined(item.sectors) ? item.sectors[0] : item.sector;
                template += '<div class=""><span class="cursor-pointer"> [' + item.processUnitBusiness.unitBusiness.txtoUnitBusiness + ' - ' + item.country.txtName + '] [' + item.processUnitBusiness.txtName + ' - ' + sector.txtNombre + ']</span></div>';
            })
        }

        return template;
    }


    buildCommentsTemplate(comments) {

        let template: string = '';

        if (comments) {

            _.forEach(comments, (item) => {
                template += '<div class=""><span class="cursor-pointer"> [' + item.dateInsert + ' - ' + item.userInsert + '] : ' + item.text + '</span></div>';
            })
        }

        return template;
    }


    buildAdditionalProposalItemTemplate(htmlAdditionalProposal, additionalProposal) {

        htmlAdditionalProposal = _.replace(htmlAdditionalProposal, '{name}', additionalProposal.name);
        htmlAdditionalProposal = _.replace(htmlAdditionalProposal, '{description}', additionalProposal.description);

        let entitiesTemplate = this.buildEntitiesTemplate(additionalProposal.entities);

        htmlAdditionalProposal = _.replace(htmlAdditionalProposal, '$ALL_ENTITIES', entitiesTemplate);

        let tagsTemplate = this.buildTagsTemplate(additionalProposal.tags);

        htmlAdditionalProposal = _.replace(htmlAdditionalProposal, '$ALL_TAGS', tagsTemplate);

        let translations = _.words(htmlAdditionalProposal, /\[.*?\]/g);

        _.forEach(translations, item => {

            let aux = _.replace(item, /\[+(.*?)\]+/g, '$1');

            let translation = this.translateService.instant(aux);

            htmlAdditionalProposal = _.replace(htmlAdditionalProposal, item, translation);

        })

        return htmlAdditionalProposal;

    }


    buildFactObservedTemplate(factObserver) {

        return new Promise(resolve => {

            this.exportConfigService.getFactObservedTemplate().subscribe(resFO => {

                this.exportConfigService.getRecommendationTemplate().subscribe(resRec => {

                    let html = this.buildFactObservedItemTemplate(resFO, resRec, factObserver);

                    resolve(html);

                })

            })

        })

    }


    buildRecommendationTemplate(recommendation) {

        return new Promise(resolve => {

            this.exportConfigService.getRecommendationTemplate().subscribe(resRec => {

                let html = this.buildRecommendationItemTemplate(resRec, recommendation);

                resolve(html);

            })

        })

    }


    buildAdditionalProposalTemplate(additionalProposal) {

        return new Promise(resolve => {

            this.exportConfigService.getAdittionalProposalTemplate().subscribe(resAP => {

                let html = this.buildAdditionalProposalItemTemplate(resAP, additionalProposal);

                resolve(html);

            })

        })

    }

}